import { inject, Injectable } from '@angular/core';
import { OrganizationCapabilityPlan } from '@core/models/organization-capability-plan.model';
import { OrganizationEntitlement } from '@core/models/organization-entitlement.model';
import { Store } from '@ngxs/store';
import { Apollo, gql } from 'apollo-angular';
import {
  GET_IF_CONTROL_TOWER_IS_ENABLED_FOR_THE_ORG_BY_ORG_ID_QUERY,
  GetIfControlTowerIsEnabledForTheOrgByIdDTO,
} from 'app/modules/dsr/queries/get-if-control-tower-is-enabled-for-the-org-by-org-id.query';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrgService {
  gql = inject(Apollo);
  store = inject(Store);

  getOrgById(orgId: string) {
    return this.gql
      .query<GetIfControlTowerIsEnabledForTheOrgByIdDTO>({
        query: GET_IF_CONTROL_TOWER_IS_ENABLED_FOR_THE_ORG_BY_ORG_ID_QUERY,
        variables: { orgId },
      })
      .pipe(map(response => response.data.getOrganizationById));
  }

  getOrganizationEntitlementsCapabilityPlan(orgId: string): Observable<{
    orgEntitlements: OrganizationEntitlement[];
    organizationCapabilityPlanByOrgId: OrganizationCapabilityPlan;
  }> {
    return this.gql
      .query<{
        orgEntitlements: OrganizationEntitlement[];
        organizationCapabilityPlanByOrgId: OrganizationCapabilityPlan;
      }>({
        query: gql`
          query OrgEntitlementsAndCapabilityPlan($orgId: String!) {
            orgEntitlements(orgId: $orgId) {
              _id
              orgId
              capabilityKey
              enabled
              permission
            }
            organizationCapabilityPlanByOrgId(orgId: $orgId) {
              _id
              orgId
              name
              defaultHomePageUrl
            }
          }
        `,
        variables: { orgId },
      })
      .pipe(
        map(response => {
          return response.data;
        })
      );
  }
}
